// export const backend_url = "http://localhost:3050";
// export const backend_url = "https://api.sandbox.payserve.co.ke";
export const backend_url = "https://api.payserve.co.ke";

// Authentication urls
export const checkEmailAndPasswordURL = "/api/auth/check_email_and_password";
export const loginURL = "/api/auth/login";
export const forgotPasswordURL = "/api/auth/forgot_password";
export const resetPasswordURL = "/api/auth/reset_password";
export const codeVerificationURL = "/api/auth/otp";
export const resendCodeURL = "/api/auth/resend_code";
export const verifyOTPURL = "/api/auth/verify_otp";
export const checkTokenExpirationURL = "/api/auth/check_jwt_expiration";
// End authentication urls


// from landlord
export const getLandlordIncomeURL = "/api/landlord/lease_management/get_customer_invoices";
export const getUnitLeaseIncomeURL = "/api/landlord/lease_management/get_unit_lease_income";
export const statementOfAccountsURL = "/api/landlord/lease_management/get_statement_of_accounts";
export const getLandlordFacilitiesURL = "/api/landlord/facility_management/get_landlord_facilities";
export const landlordUnitsURL = "/api/landlord/unit_management/get_units";
export const getApprovalTicketsURL = "/api/landlord/maintenance_approvals/get_tickets_approvals";
export const getApprovalTicketURL = "/api/landlord/maintenance_approvals/get_ticket_approval";
export const approveWorkOrderURL = "/api/landlord/maintenance_approvals/approve_ticket";
export const denyWorkOrderURL = "/api/landlord/maintenance_approvals/deny_ticket";

export const getWalletHistoryURL = "/api/landlord/wallet_management/get_wallet_history";
export const getWalletBalanceURL = "/api/landlord/wallet_management/get_wallet_balance";
export const requestWithdrawalURL = "/api/landlord/wallet_management/request_withdrawal";
// end landlord

// from resident
export const residentUnitsURL = "/api/resident/dashboard/get_units";
export const residentFacilitiessURL = "/api/resident/dashboard/get_facilities";
export const getInvoice = "/api/app/levy_management/get_invoice_by_id";
export const getCustomerInvoicesURL = "/api/resident/invoice_management/get_customer_invoices";
export const getTicketsURL = "/api/resident/ticket_management/get_tickets";

// end resident

// Lease urls
export const getLeaseInvoicesURL = "/api/resident/resident_leases/get_customer_lease_invoices";
// end resident



// from app
export const getUnitUrl = "/api/app/unit_management/get_unit";
export const getCompanyInformationURL = "/api/app/settings_management/get_company_information";
export const get_lease = "/api/app/lease_management/lease_agreements/get_lease";
export const recordCashPayment = "/api/app/payment_management/cash/record_cash_payment";
export const getFacilityUnits = "/api/app/unit_management/get_facility_units";




